export default __webpack_public_path__ + "static/media/DSC_7614.3536f1b9.jpg";